import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initMsal, msalInstance } from "./auth/msal";
import { MsalProvider } from "@azure/msal-react";
import { AuthProvider } from "./auth"; 
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";

async function bootstrap() {
  await initMsal();

  const container = document.getElementById("root");
  if (!container) throw new Error("Elemento #root não encontrado");

  const root = ReactDOM.createRoot(container as HTMLElement);

  window.addEventListener("error", (e) => {
  console.error("💥 GlobalError:", e.error);
  });
  window.addEventListener("unhandledrejection", (e) => {
    console.error("💥 UnhandledPromise:", e.reason);
  });


root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <ErrorBoundary fallbackRender={({ error }) => (
          <div style={{ padding: 20, color: "red" }}>
            💥 Erro capturado: {String(error.message || error)}
            <pre>{error.stack}</pre>
          </div>
        )}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ErrorBoundary>
      </AuthProvider>
    </MsalProvider>
  </React.StrictMode>
);

}

bootstrap();
